import { locale } from './../../ModuleEditor/util/locale-wrapper';

const TERM_DISPLAY = {
  CAMPAIGN_RULES: 'campaign_rules',
  NO_EMBED:       'no_embed',
  EXTERNAL_LINK:  'external_link',
};

const TERM_DISPLAY_ALL = _.values(TERM_DISPLAY, 'value');

const TERM_DISPLAY_LIST = [
  { text: locale('No link required'), value: TERM_DISPLAY.NO_EMBED, description: '' },
  { text: locale('Rules defined within this experience'), value: TERM_DISPLAY.CAMPAIGN_RULES, description: '' },
  { text: locale('External URL'), value: TERM_DISPLAY.EXTERNAL_LINK, description: '' },
];

export { TERM_DISPLAY, TERM_DISPLAY_LIST, TERM_DISPLAY_ALL };

export default TERM_DISPLAY;
